import React from "react";
import Spinner from "./Spinner";
import LightTheme from "../theme/LightTheme";

interface Props {
  children: React.ReactNode;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

const GradientButton = ({
  children,
  onClick,
  isLoading = false,
  disabled = false,
}: Props) => (
  <button disabled={disabled} type="button" onClick={onClick}>
    <div>{isLoading ? <Spinner /> : children}</div>
    <style jsx>{`
      button {
        padding: 4px;
        border-radius: 6px;
        border: none;
        height: 40px;
        font-weight: 600;
        font-size: 1rem;
        color: #ffffff;
        text-decoration: none;
        align-items: center;
        display: flex;
        justify-content: center;
        background: grey;
        white-space: nowrap;
        box-sizing: border-box;
      }
      div {
        padding: 0 20px;
      }
      button:enabled {
        background: ${LightTheme.gradientBackground};
      }
      button:enabled:hover {
        background: ${LightTheme.gradientBackground};
        cursor: pointer;
        color: white;
      }
      button:enabled:active {
        color: black;
      }
      button:enabled:active div {
        background: white;
        width: 100%;
        height: 100%;
        border-radius: 3px;
        align-items: center;
        display: flex;
        justify-content: center;
      }
    `}</style>
  </button>
);

export default GradientButton;
